import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, BarChart3, Monitor } from "lucide-react";
import PageHero from "../components/PageHero";
import { FORMATIONS, FORMATION_CATALOG } from "../mock/mock";

const Formations = () => {
  return (
    <div>
      <PageHero
        title="Formations"
        subtitle="Une programmation complète en gouvernance TI, agilité et gestion de projet."
        image="https://images.unsplash.com/photo-1776039325185-8fd3d46af4e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />

      {/* Two modes */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
          {FORMATIONS.map((f) => (
            <div key={f.id} className="group relative overflow-hidden rounded-lg shadow-md">
              <div className="h-[300px] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{ backgroundImage: `url(${f.image})` }} />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f2740]/95 via-[#0f2740]/45 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-white text-2xl font-bold uppercase tracking-[0.12em] mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>{f.title}</h3>
                <p className="text-white/80 text-sm leading-relaxed">{f.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Catalog */}
      <section className="bg-[#f4f6f9] py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col items-center text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-[#15324f] uppercase tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Notre programmation
            </h2>
            <div className="w-16 h-[3px] bg-[#2f80c4] mt-5" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {FORMATION_CATALOG.map((c) => (
              <div key={c.id} className="bg-white rounded-lg shadow-sm p-7 hover:shadow-lg transition-shadow duration-300 border-l-4 border-[#2f80c4]">
                <span className="inline-block text-[11px] font-bold uppercase tracking-wide text-[#2f80c4] bg-[#2f80c4]/10 px-3 py-1 rounded mb-4">{c.level}</span>
                <h3 className="text-lg font-bold text-[#15324f] mb-3 leading-snug" style={{ fontFamily: "'Montserrat', sans-serif" }}>{c.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-5">{c.description}</p>
                <div className="flex flex-wrap items-center gap-4 text-xs text-slate-500 border-t border-slate-100 pt-4">
                  <span className="flex items-center gap-1.5"><Clock size={14} className="text-[#2f80c4]" /> {c.duration}</span>
                  <span className="flex items-center gap-1.5"><Monitor size={14} className="text-[#2f80c4]" /> {c.mode}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            { icon: Monitor, title: "En entreprise ou en ligne", text: "Nos formations s'adaptent à votre réalité : dans vos locaux, dans les nôtres ou à distance." },
            { icon: BarChart3, title: "Contenus sur mesure", text: "Des programmes adaptés à votre niveau de maturité et à vos objectifs organisationnels." },
            { icon: Clock, title: "Accompagnement durable", text: "Un suivi post-formation pour ancrer les apprentissages dans vos pratiques." }
          ].map((b) => (
            <div key={b.title} className="text-center px-4">
              <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-[#2f80c4]/10 flex items-center justify-center">
                <b.icon size={26} className="text-[#2f80c4]" />
              </div>
              <h4 className="text-lg font-bold text-[#15324f] mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>{b.title}</h4>
              <p className="text-slate-600 text-sm leading-relaxed">{b.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#15324f] py-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Formez vos équipes dès maintenant
          </h2>
          <p className="text-white/75 mb-8">Demandez notre calendrier de formations et nos tarifs de groupe.</p>
          <Link to="/nous-joindre" className="inline-flex items-center gap-2 bg-[#2f80c4] text-white px-8 py-4 text-sm font-semibold uppercase tracking-wide rounded hover:bg-white hover:text-[#15324f] transition-colors duration-300" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Nous joindre <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Formations;
